import(/* webpackMode: "eager" */ "/vercel/path0/components/about-us/our-locations.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/common/bread-crumbs.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/doctors-details/Blog.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/doctors-details/doctors-details.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/doctors-details/Videos.js");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/vercel/path0/components/ui/accordion.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["Slot"] */ "/vercel/path0/node_modules/@radix-ui/react-slot/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/errorpage/error-img.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/footer-images/app-store.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/footer-images/play-store.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/locations-images/mobile-app.png");
